import { modals, Stack, Button, Text, DataList, DataItem } from '@cad-arc';
import { EventDetailsTabServiceRotationGroup, EventPanelFormType } from '@mark43/cad-api';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { TabIndented } from '../../../../../panels/entity-panels/tabs/tab-indented';
import { CancelServiceRotationModal } from '../../../../cancel-service-rotation-modal';
import { useIntegratedForm } from '../../../../../forms/use-integrated-form';
import { useSetActiveEventPanelTab } from '../../../../active-event-panel-tab-provider';
import { onTowRotationCancellation } from '../../../../event-panel-form/helpers/vehicle-helpers';
import { useDrawerControls } from '../../../../../drawers/components/drawer-context-provider';

export function ServiceRotationSection({
    serviceRotationGroups,
}: {
    serviceRotationGroups: EventDetailsTabServiceRotationGroup[];
}): React.ReactElement {
    const eventForm = useIntegratedForm<EventPanelFormType>().form;
    const setActiveEventPanelTab = useSetActiveEventPanelTab();

    const drawerControls = useDrawerControls();
    // Grab all the tow vehicles and find if any of them are using the same rotation service list as this one.
    // If they are, then switch to the vehicle tab and also clear out fields
    const handleCancelServiceRotationSuccess = (rotationServiceListPositionId: number) => {
        const towVehicles = eventForm.getValues('towVehicles');

        const towVehicleAssociatedWithServiceRotationIndex = towVehicles.findIndex((towVehicle) => {
            return towVehicle.rotationServiceListPositionId === rotationServiceListPositionId;
        });

        if (towVehicleAssociatedWithServiceRotationIndex > -1) {
            onTowRotationCancellation({
                eventForm,
                baseKey: 'towVehicles',
                index: towVehicleAssociatedWithServiceRotationIndex,
                openDrawer: drawerControls.open,
            });
            setActiveEventPanelTab('VEHICLES');
        }
    };
    return (
        <TabSection title="Service Rotation" testId="SERVICE_ROTATION_SECTION">
            {!!serviceRotationGroups.length && (
                <Stack spacing={3}>
                    {serviceRotationGroups.map((serviceRotationGroup) => {
                        return (
                            <Stack key={serviceRotationGroup.name}>
                                <Text color="tertiary">{serviceRotationGroup.name}</Text>

                                <TabIndented>
                                    <Stack>
                                        {serviceRotationGroup.eventDetailsTabServiceRotationDtos.map(
                                            (eventDetailsTabServiceRotationDto) => {
                                                return (
                                                    <Stack
                                                        justifyContent="space-between"
                                                        direction="row"
                                                        key={
                                                            eventDetailsTabServiceRotationDto.rotationServiceListPositionId
                                                        }
                                                    >
                                                        <DataList>
                                                            <DataList direction="row">
                                                                <DataItem dataKey="Provider">
                                                                    {
                                                                        eventDetailsTabServiceRotationDto.serviceProviderName
                                                                    }
                                                                </DataItem>
                                                                <DataItem dataKey="Response">
                                                                    {
                                                                        eventDetailsTabServiceRotationDto.response
                                                                    }
                                                                </DataItem>
                                                            </DataList>
                                                            <DataItem dataKey="Rotation Comments">
                                                                {
                                                                    eventDetailsTabServiceRotationDto.reason
                                                                }
                                                            </DataItem>
                                                        </DataList>
                                                        <Button
                                                            size="sm"
                                                            variant="ghost"
                                                            onClick={() => {
                                                                const rotationServiceListPositionId =
                                                                    eventDetailsTabServiceRotationDto.rotationServiceListPositionId;

                                                                modals.blank({
                                                                    children: ({ onClose }) => (
                                                                        <CancelServiceRotationModal
                                                                            serviceTypeName={
                                                                                serviceRotationGroup.name
                                                                            }
                                                                            onClose={() => {
                                                                                onClose();
                                                                                handleCancelServiceRotationSuccess(
                                                                                    rotationServiceListPositionId
                                                                                );
                                                                            }}
                                                                            id={
                                                                                rotationServiceListPositionId
                                                                            }
                                                                        />
                                                                    ),
                                                                });
                                                            }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                    </Stack>
                                                );
                                            }
                                        )}
                                    </Stack>
                                </TabIndented>
                            </Stack>
                        );
                    })}
                </Stack>
            )}
        </TabSection>
    );
}
